module.exports = __webpack_public_path__ + "static/img/bg_received_bag.176df053.png";